<template>
	<div id="resultList" class="resultList">
		<div class="list-table">
			<div v-for="(item, index) in data " :key="index" class="list-table-item">
				<div class="list-table-item__left">
					<img v-if="item.isRecommend == 1" class="recommendation" src="@/assets/img/client/check/Recommend.png" width="50" height="50">
					<div class="flex flex-column-center padding-top_7 padding-bottom_7">
						<div class="flex  list-table-item__left-channelName" style="align-items: center;">
							<img v-if="item.isRecommend == 1" src="@/assets/img/client/check/RecommendIcon.png" width="18" height="18">
							<div class="channel-name-text">{{ item.channelName }} </div> 
							<div class="tag-mode" >{{item.modeCodes}}</div>
						</div>
					</div>
					<div class="flex list-table-item__left-center padding-top_12 padding-bottom_12" >
						<img v-if="getChannelIcon(item)" class="channel-icon" :src="getChannelIcon(item)" width="50" height="50"  >
						<div class="left-center_item">
							<div class="flex" >
								<div style="width: 16px;height: 16px;text-align: center;"><img src="@/assets/img/client/check/DeliveryIcon.png" width="10" height="10" ></div>
								<span class="text1 margin-left_8" >交货</span>
								<span class="text2 margin-left_8" >{{ item.destinationName }}</span>
							</div>
							<div style="height: 20px;border-left: 1px dashed #E1E1E1;margin-left: 7px;"></div>
							<div  class="flex">
								<div style="width: 16px;height: 16px;text-align: center;"><img src="@/assets/img/client/check/DepartureIcon.png" width="8" height="10" ></div>
								<span class="text1 margin-left_8">起运</span>
								<span class="text2 margin-left_8">{{ item.originNameCn }}</span>
							</div>
						</div>
						<div class="left-center_item" style="border-left: 1px solid #E1E1E1;padding-left: 15px;">
							<div>
								<span style="font-size: 24px;font-weight: bold;">{{item.workDays}}</span>
								<span style="font-size: 16px;font-weight: bold;">自然日</span>
							</div>
							<div class="text1">预估时效（发货-签收）</div>
						</div>
						<div class="left-center_item" style="border-left: 1px solid #E1E1E1;padding-left: 15px;">
							<div v-if="item.totalAmount>0" class=" text4">￥{{ item.totalAmount.toFixed(2) }}</div>
							<div v-else class="text1">单询</div>
							<div class="flex flex-row-center text1" style="justify-content: space-evenly;">
								<div>单价 <span class="text2">￥{{(item.totalAmount/item.chargeWeight).toFixed(2)}}/KG</span></div>
								<div class="margin-left_24">计费重 <span class="text2">{{item.chargeWeight}}KG</span></div>
							</div>
						</div>
					</div>
					<div class="flex margin-top_8 list-table-item__left-cargoTypeNames" :title="item.cargoTypeNames">	
						<img src="@/assets/img/client/check/pic_nodata@2x(1).png" width="16" height="16" style="margin-right: 5px;">
						<div class="text2">{{item.cargoTypeNames}}</div>
					</div>
				</div>
				<div class="list-table-item__right flex flex-column  flex-column-center" style="justify-content: space-evenly">
					<div style="text-align: right;width: 100%;">
						<div class="detail-btn" @click="toDetail(item)"><span>方案明细 ></span></div>
					</div>
					<button class="choose-btn" @click="toOrder(item)"><span>立即下单</span></button>
					<div class="inline-ask-btn flex flex-column-center flex-row-center" @click.stop.prevent="clickChat(item)">
						<img src="@/assets/img/client/check/ask.png" alt="air" width="16" height="16">
						<span class="margin-left_4">立即咨询</span>
					</div>
				</div>
			</div>
		</div>
		<ChatDialog v-if="chatVisible" ref="ChatDialog" @close="closeChat" />
		<ExpDetailDialog ref="ExpDetailDialog" :is-show="detailDialogShow" :detail="detailInfo" @close="(val) => { detailDialogShow = val}" />
		<ConfirmOrder v-show="confirmOrderVisible" ref="ConfirmOrder" @close="closeConfirm" />
	</div>
</template>

<script>
	import {
		CreateFBAOrder,
		CreateAirOrder,
		CreateExpOrder,
		CreateSeaOrder
	} from '@/api/order.js'
	import {
		GetChatUserId
	} from '@/api/user.js'
	import ChatDialog from '@/client/home/chatBox/index.vue'
	import ExpDetailDialog from './expDetailDialog.vue'
	import ConfirmOrder from '@/client/home/placeAnOrder/index.vue'
	export default {
		name: 'FbaResultList',
		components: {
			// 组件的引用
			ChatDialog,
			ExpDetailDialog,
			ConfirmOrder
		},
		props: {
			// 父辈向子辈传参
			sortTitle: ''
		},
		data() {
			return {
				data: undefined,
				inputData: undefined,
				chatVisible: false,
				detailDialogShow: false,
				detailInfo: {},
				confirmOrderVisible: false
			}
		},
		computed: {},
		watch: {
			// 监测变化
		},
		created() {
			// 实例被创建之后执行代码
			// this.openConfirm('FBA2407110005', 3)
		},
		mounted() {
			// 页面进入时加载内容
		},
		methods: {
			closeConfirm() {
				this.confirmOrderVisible = false
			},
			// 查看渠道详情
			toDetail(item) {
				this.detailInfo = {
					...item,
					...this.inputData
				}
				this.detailDialogShow = true
				this.$nextTick(() => {
					this.$refs.ExpDetailDialog.init(this.inputData)
				})
			},
			closeChat() {
				this.chatVisible = false
			},
			clickChat(item) {
				GetChatUserId().then(res => {
					if (res.code === 200) {
						this.chatVisible = true
						this.$nextTick(() => {
							this.$refs.ChatDialog.init(this.inputData, item, res.data)
						})
					}
				})
			},
			init(data, inputData) {
				this.data = data
				this.inputData = inputData
			},
			getSubTotal(item) {
				var total = 0
				if (item.feeList) {
					item.feeList.forEach((item) => {
						total += item.amount
					})
				}
				if (
					item.startLiftgateAmount > 0 &&
					item.businessType != 2 &&
					item.businessType != 4
				) {
					total += item.startLiftgateAmount
				}
				if (
					item.pickupAmount > 0 &&
					item.businessType != 2 &&
					item.businessType != 4
				) {
					total += item.pickupAmount
				}
				return total.toFixed(2)
			},
			getBusinessType(item) {
				switch (item.businessType) {
					case 1:
						return `Express`
					case 2:
						return `Air`
					case 3:
						return `Ocean`
					case 4:
						return `Ocean`
				}
			},
			getMode(item) {
				switch (item.businessType) {
					case 1:
						return `国际快递`
					case 2:
						return `空卡`
					case 3:
						return `空派`
					case 4:
						return `海运`
					case 5:
						return `铁路专线`
					case 6:
						return `海卡`
					case 7:
						return `整板空运`
					case 8:
						return `海运整柜`
					case 9:
						return `空运拼单`
					case 10:
						return `海运拼箱`
					case 11:
						return `海运自提`
				}
			},
			GetType(item) {
				switch (item.businessType) {
					case 2:
						switch (item.calculationType) {
							case 1:
								return `门到门`
							case 2:
								return `门到机场`
							case 3:
								return `机场到机场`
							case 4:
								return `机场到门`
						}
						break
					case 4:
						switch (item.calculationType) {
							case 1:
								return `门到门`
							case 2:
								return `门到港口`
							case 3:
								return `港口到港口`
							case 4:
								return `港口到门`
						}
						break
				}
				return ''
			},
			getAddress(item) {
				switch (item.businessType) {
					case 1:
						return `${item.originZipcode},${item.originName} - ${this.inputData.DestinationZipCode},${this.inputData.DestinationAddressCode}`
					case 2:
						return `${this.inputData.OriginZipCode},${this.inputData.OriginAddressCode} - ${item.startPortCode} - ${item.destPortCode} - ${this.inputData.DestinationZipCode},${this.inputData.DestinationAddressCode}`
					case 3:
						return `${this.inputData.OriginZipCode},${this.inputData.OriginAddressCode} —— #${this.inputData.FbaWarehouseCode} - ${item.destinationZipcode},${item.destinationName}`
				}
			},
			changeType(item) {
				switch (item.businessType) {
					case 1:
						return `Express`
					case 2:
						return `Air`
					case 3:
						return `Ocean`
					case 4:
						return `Ocean`
				}
			},
			// 方法
			// 点击标题展开内容
			clkxShow(item, index) {
				this.data.forEach((res, i) => {
					if (index === i) {
						this.$set(res, 'isTrue', !item.isTrue)
					}
				})
			},
			openConfirm(orderNo, businessType) {
				this.confirmOrderVisible = true
				this.$nextTick(() => {
					this.$refs.ConfirmOrder.init(orderNo, businessType)
				})
			},
			toOrder(item) {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)',
					customClass: 'is-loading-style'
				})
				switch (item.businessType) {
					case 1: // 快递
						this.createExpOrder(item, loading)
						break
					case 2: // 空运
						this.createAirOrder(item, loading)
						break
					case 3: // fab
						this.createFbaOrder(item, loading)
						break
					case 4: // 海运
						this.createSeaOrder(item, loading)
						break
				}
			},
			createFbaOrder(item, loading) {
				var param = {
					isDraft: true,
					startCityId: this.inputData.OriginCityId,
					destCountryId: this.inputData.DestinationCountryId,
					storeCode: this.inputData.FbaWarehouseCode,
					quantity: this.inputData.TotalQuantity,
					weight: this.inputData.TotalWeight,
					volume: this.inputData.TotalVolume,
					channelId: item.channelId,
					totalValue: this.inputData.GoodsValue,
					buyInsurance: this.inputData.IsInsurance ? 1 : 0,
					productName: this.inputData.GoodsName,
					goodsReadyType: this.inputData.GoodsReadyType,
					goodsReadyTime: this.inputData.GoodsReadyTime,
					isKnowerShipper: this.inputData.IsKnown ? 1 : 0,
					isCustomsBrokerage: this.inputData.IsCustomsBrokerage ? 1 : 0,
					isBond: this.inputData.IsBond ? 1 : 0,
					bondType: this.inputData.BondType,
					isLiftgatePickup: this.inputData.IsLiftgatePickup ? 1 : 0,
					isLiftgateDelivery: this.inputData.IsLiftgateDelivery ? 1 : 0,
					cargoTypeIds: this.inputData.GoodsType
				}
				if (!this.inputData.FbaWarehouseCode) {
					param.addressType = 100
					param.consignee = {
						zipCode: this.inputData.DestinationZipCode,
						countryId: this.inputData.DestinationCountryId,
						cityName: this.inputData.DestinationAddressCode
					}
				}
				CreateFBAOrder(param).then(res => {
					loading.close()
					if (res.code === 200) {
						var orderNo = res.data
						this.openConfirm(orderNo, 3)
					}
				}).finally(() => {
					loading.close()
				})
			},
			createExpOrder(item, loading) {
				var param = {
					isDraft: true,
					startCityId: this.inputData.OriginCityId,
					destCityId: this.inputData.DestinationCityId,
					destCountryId: this.inputData.DestinationCountryId,
					quantity: this.inputData.TotalQuantity,
					weight: this.inputData.TotalWeight,
					volume: this.inputData.TotalVolume,
					channelId: item.channelId,
					cargoValue: this.inputData.GoodsValue,
					feeList: item.feeList,
					orderAmount: item.totalAmount,
					buyInsurance: this.inputData.IsInsurance ? 1 : 0,
					productName: this.inputData.GoodsName,
					goodsReadyType: this.inputData.GoodsReadyType,
					goodsReadyTime: this.inputData.GoodsReadyTime,
					isKnowerShipper: this.inputData.IsKnown ? 1 : 0,
					isLiftgatePickup: this.inputData.IsLiftgatePickup ? 1 : 0,
					totalValue: this.inputData.GoodsValue,
					destZipCode: this.inputData.DestinationZipCode,
					cargoTypeIds: this.inputData.GoodsType
				}
				CreateExpOrder(param).then((res) => {
					loading.close()
					if (res.code === 200) {
						var orderNo = res.data
						this.openConfirm(orderNo, 1)
					}
				}).finally(() => {
					loading.close()
				})
			},
			createAirOrder(item, loading) {
				var priceInfo = item.feeList.find((item) => item.name === 'AIR FREIGHT')
				var param = {
					airChannelId: item.channelId,
					airCompanyCode3: item.airCompanyCode3,
					destAirPortCode3: item.destPortCode,
					startAirPortCode3: item.startPortCode,
					weight: item.totalWeight,
					volume: item.totalVolume,
					quantity: item.totalQuantity,
					validTerm: item.workDays,
					airCompanyId: item.airCompanyId,
					airArrivalType: item.airArrivalType,
					orderServiceType: item.calculationType,
					planDeliveryTime: item.goodsReadTime,
					queryValidTime: item.expirationTime,
					orderTrafficAmount: priceInfo.amount,
					orderAmount: item.totalAmount,
					chargeWeight: priceInfo.units,
					costUnitPrice: priceInfo.unitPrice,
					goodsReadyType: this.inputData.GoodsReadyType,
					isKnowerShipper: this.inputData.IsKnown ? 1 : 0,
					buyInsurance: this.inputData.IsInsurance ? 1 : 0,
					goodsValue: this.inputData.GoodsValue,
					isCustomsBrokerage: this.inputData.IsCustomsBrokerage ? 1 : 0,
					isBond: this.inputData.IsBond ? 1 : 0,
					bondType: this.inputData.BondType,
					isLiftgatePickup: this.inputData.IsLiftgatePickup ? 1 : 0,
					isLiftgateDelivery: this.inputData.IsLiftgateDelivery ? 1 : 0,
					bondAmount: item.bondAmount,
					destLiftgateAmount: item.destLiftgateAmount,
					startLiftgateAmount: item.startLiftgateAmount,
					feeList: [
						...item.feeList.filter((item) => item.name !== 'AIR FREIGHT'),
						...item.destFeeList,
						...item.customsFeeList,
						...item.originFeeList
					],
					startCityId: item.originCityId,
					destCityId: item.destCityId,
					destCountryId: item.destinationCountryId,
					destSvcId: item.destSvcId,
					pickupAmount: item.pickupAmount,
					cargoIDs: this.inputData.GoodsType.join(',')
				}
				var deliveryInfo = item.destFeeList.find(
					(x) => x.name == 'AIR DELIVERY FREIGHT'
				)
				if (deliveryInfo != undefined) {
					param.deliveryAmount = deliveryInfo.amount
				}
				CreateAirOrder(param).then((res) => {
					loading.close()
					if (res.code === 200) {
						var orderNo = res.data
						this.openConfirm(orderNo, 2)
					}
				}).finally(() => {
					loading.close()
				})
			},
			createSeaOrder(item, loading) {
				var priceInfo = item.feeList.find((item) => item.name === 'SEA FREIGHT')
				var param = {
					shipPortCode: item.startPortCode,
					destPortCode: item.destPortCode,
					channelId: item.channelId,
					quantity: item.totalQuantity,
					weight: item.totalWeight,
					volume: item.totalVolume,
					orderAmount: item.amount,
					ServiceType: item.calculationType,
					planDeliveryTime: item.goodsReadTime,
					charge: priceInfo.units,
					unitPrice: priceInfo.unitPrice,
					costAmount: priceInfo.amount,
					totalAmount: item.totalAmount,
					workDays: item.workDays,
					goodsReadyType: this.inputData.GoodsReadyType,
					isKnowerShipper: this.inputData.IsKnown ? 1 : 0,
					buyInsurance: this.inputData.IsInsurance ? 1 : 0,
					priceEndDate: item.expirationTime,
					shipCompanyCode: item.modeCodes,
					goodsValue: this.inputData.GoodsValue,
					isCustomsBrokerage: this.inputData.IsCustomsBrokerage ? 1 : 0,
					isBond: this.inputData.IsBond ? 1 : 0,
					bondType: this.inputData.BondType,
					isLiftgatePickup: this.inputData.IsLiftgatePickup ? 1 : 0,
					isLiftgateDelivery: this.inputData.IsLiftgateDelivery ? 1 : 0,
					bondAmount: item.bondAmount,
					destLiftgateAmount: item.destLiftgateAmount,
					startLiftgateAmount: item.startLiftgateAmount,
					startCityId: item.originCityId,
					destCityId: item.destCityId,
					destCountryId: item.destinationCountryId,
					feeList: [
						...item.feeList.filter((item) => item.name !== 'SEA FREIGHT'),
						...item.destFeeList,
						...item.customsFeeList,
						...item.originFeeList
					],
					destSvcId: item.destSvcId,
					pickupAmount: item.pickupAmount
				}
				var deliveryInfo = item.destFeeList.find(
					(x) => x.name == 'SEA DELIVERY FREIGHT'
				)
				if (deliveryInfo != undefined) {
					param.deliveryAmount = deliveryInfo.amount
				}
				CreateSeaOrder(param).then((res) => {
					loading.close()
					if (res.code === 200) {
						var orderNo = res.data
						this.openConfirm(orderNo, 4)
					}
				}).finally(() => {
					loading.close()
				})
			},
			filteredDestFeeList(item) {
				return item.destFeeList.filter(
					(fee) => fee.name != 'AIR DELIVERY FREIGHT'
				)
			},
			usedDestFeeList(item) {
				return item.destFeeList.filter(
					(fee) => fee.name == 'AIR DELIVERY FREIGHT'
				)
			},
			destFeeSum(item) {
				var list = this.filteredDestFeeList(item)
				if (list) {
					return list
						.reduce((accumulator, item) => accumulator + item.amount, 0)
						.toFixed(3)
				} else {
					return 0
				}
			},
			destFeeUesdSum(item) {
				var list = this.usedDestFeeList(item)
				if (list) {
					return (
						list.reduce((accumulator, item) => accumulator + item.amount, 0) +
						parseFloat(item.destLiftgateAmount)
					).toFixed(3)
				} else {
					return 0
				}
			},
			customsFeeSum(item) {
				var customsFee = 0
				if (item.customsFeeList) {
					customsFee = parseFloat(
						item.customsFeeList.reduce(
							(accumulator, customsFee) => accumulator + customsFee.amount,
							0
						)
					)
				}
				return (
					parseFloat(item.ISFBondAmount) +
					parseFloat(item.bondAmount) +
					customsFee
				).toFixed(3)
			},
			originFeeSum(item) {
				if (item.originFeeList) {
					return item.originFeeList
						.reduce(
							(accumulator, customsFee) => accumulator + customsFee.amount,
							0
						)
						.toFixed(3)
				} else {
					return 0
				}
			},
			pickupFeeSum(item) {
				return (
					parseFloat(item.startLiftgateAmount) + parseFloat(item.pickupAmount)
				).toFixed(3)
			},
			getChannelIcon(item){
				if(item.modeCodes){
					if(item.modeCodes.includes('DHL')){
						return require('@/assets/img/client/check/Exp-DHL.png')
					}else if(item.modeCodes.includes('UPS')){
						return require('@/assets/img/client/check/Exp-ups.png')
					}else if(item.modeCodes.includes('FEDEX')){
						return require('@/assets/img/client/check/Exp-FedEx.png')
					}else{
						return undefined
					}
				}
				
			}
		}
	}
</script>
<style scoped lang="scss">
	.resultList {
		margin-top: 16px;

		.list-main {
			padding: 0;

			li {
				width: 1200px;
				//height: 160px;
				background: #ffffff;
				border-radius: 8px;
				border: 1px solid rgba(233, 85, 6, 0);
				margin: 8px 0;
				overflow: hidden;
				cursor: pointer;

				.list-item {
					width: 1200px;
					height: 160px;
					background: #ffffff;
					border-radius: 8px;
					border: 1px solid rgba(233, 85, 6, 0);
					display: flex;

					.list-left {
						width: 70%;
						text-align: left;
						margin: 16px;
						border-right: 1px solid #dddddd;

						.div-tag {
							display: flex;

							.list-tag {
								width: 88px;
								height: 25px;
								background: rgba(2, 127, 252, 0.08);
								border-radius: 13px;
								font-size: 13px;
								font-family: PingFangSC, PingFang SC;
								font-weight: 500;
								color: #027ffc;
								text-align: center;
								line-height: 25px;
								margin-left: 5px;
								display: inline-block;
							}
						}

						div:nth-of-type(2),
						div:nth-of-type(3) {
							height: 32px;
							display: flex;
							align-items: center;
							font-size: 14px;
							font-family: D, D;
							font-weight: normal;
							color: #333333;
						}

						button {
							width: 100px;
							height: 32px;
							background: rgba(233, 85, 6, 0);
							border-radius: 8px;
							border: 1px solid rgba(233, 85, 6, 0.24);
							font-size: 14px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 500;
							color: #e95506;
						}

						.p-line {
							width: 16px;
							height: 1px;
							background: #aaaaaa;
							display: block;
							margin: 0 8px;
						}

						.p-plus {
							color: #aaaaaa;
							display: block;
							margin: 0 8px;
						}
					}

					.list-middle {
						width: 20%;
						margin: 18px 16px;
						text-align: center;

						div:nth-of-type(1) {
							font-size: 18px;
							font-family: D-DINExp, D-DINExp;
							font-weight: bold;
							color: #333333;
							height: 32px;
						}

						button {
							width: 108px;
							height: 32px;
							background: #e95506;
							border-radius: 8px;
							border: 1px solid #e95506;
							font-size: 16px;
							font-family: D-DINExp, D-DINExp;
							font-weight: bold;
							color: #ffffff;
							cursor: pointer;
						}

						div:nth-of-type(2) {
							font-size: 13px;
							font-family: D, D;
							font-weight: normal;
							margin: 10px 0;

							span:nth-of-type(1) {
								color: #aaaaaa;
								margin-right: 8px;
							}

							span:nth-of-type(2) {
								color: #333333;
							}
						}

						div:nth-of-type(3) {
							font-size: 13px;
							font-family: D, D;
							font-weight: normal;
							color: #333333;
						}
					}

					.list-right {
						width: 10%;
						font-size: 12px;
						margin: 16px;
						width: 24px;
						height: 128px;
						background: rgba(233, 85, 6, 0.06);
						border-radius: 4px;
						color: #e95506;
						display: flex;
						align-items: center;
						justify-content: center;
					}
				}

				.list-card {
					.card-title {
						width: 895px;
						height: 40px;
						background: rgba(170, 170, 170, 0.08);
						font-size: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						color: #333333;
						line-height: 40px;
						text-align: left;
						padding-left: 16px;
					}

					.card-table {
						table {
							width: 895px;
							border-collapse: collapse;
							text-align: left;
							padding: 0 8px;

							tr:nth-of-type(1) {
								td {
									font-size: 13px;
									font-family: PingFangSC, PingFang SC;
									font-weight: 550;
									color: #333333;
								}
							}

							tr {
								height: 40px;

								td {
									border-bottom: 1px solid rgba(170, 170, 170, 0.24);
									font-size: 13px;
									font-family: PingFangSC, PingFang SC;
									font-weight: 400;
									color: #333333;
									padding: 0 16px;
								}

								td:last-child {
									text-align: right;
								}
							}
						}
					}

					.card-subtotal {
						font-size: 14px;
						font-family: D-DINExp, D-DINExp;
						font-weight: bold;
						color: #333333;
						height: 40px;
						line-height: 40px;
						text-align: right;
						padding-right: 16px;
					}

					.card-total {
						height: 40px;
						line-height: 40px;
						text-align: right;
						background: rgba(2, 127, 252, 0.08);
						font-size: 16px;
						font-family: D-DINExp, D-DINExp;
						font-weight: bold;
						color: #333333;
						padding-right: 16px;
					}

					.card-remarks {
						width: 863px;
						height: 161px;
						background: rgba(0, 0, 0, 0.02);
						border-radius: 8px;
						margin: 16px;
						text-align: left;
						overflow-y: scroll;

						p {
							padding: 4px 8px;
							margin: 0;
						}

						span {
							padding: 0 8px;
							display: block;
						}
					}
				}
			}
		}

		.list-table {
			width: 1200px;

			.list-table-item {
				margin-top: 16px;
				width: 1200px;
				padding: 16px 0;
				display: flex;
				justify-content: space-between;
				align-items: stretch;
				background: #ffffff;
				box-shadow: 0px 2px 8px 0px rgba(25, 78, 203, 0.04);
				border-radius: 8px;
				border: 1px solid rgba(233, 85, 6, 0);
				transition: border 0.3s;
				box-sizing: border-box;

				&:hover {
					border: 1px solid #3370ff;
				}

				.list-table-item__left {
					width: 950px;
					padding: 0 16px 0 80px;
					box-sizing: border-box;
					position: relative;

					.filter-button-show {
						visibility: visible;
					}

					.filter-button1 {
						visibility: hidden;
						display: inline-block;
						min-width: 64px;
						min-height: 24px;
						padding: 3px 8px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 600;
						font-size: 12px;
						color: #3370ff;
						line-height: 17px;
						// text-align: center;
						font-style: normal;
						background: rgba(2, 127, 252, 0.08);
						border-radius: 8px 0px 8px 0px;
						box-sizing: border-box;
					}
					.list-table-item__left-channelName{

						.tag-mode{
							font-size: 12px;
							background: #E5EDFF;
							border-radius: 6px 6px 6px 6px;
							border: 1px solid #3370FF;
							color: #3370FF;
							padding: 2px 5px;
							margin-left: 5px;
						}
						
						.tag-tax{
							font-size: 12px;
							background: #EFF8EA;
							border-radius: 6px 6px 6px 6px;
							border: 1px solid #34BE46;
							color: #34BE46;
							padding: 2px 5px;
							margin-left: 5px;
						}
						
						.channel-name-text {
							font-family: D, D;
							font-weight: normal;
							font-size: 14px;
							color: #333333;
							font-weight: bold;
							line-height: 16px;
							text-align: left;
							font-style: normal;
							margin-left: 5px;
						}
					}
					
					
					.recommendation{
						position: absolute;
						top: -16px;
						left: 0;
					}

					.text2 {
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 13px;
						color: #aaaaaa;
						line-height: 18px;
						text-align: left;
						font-style: normal;
					}

					.line {
						width: 16px;
						height: 1px;
						background: #aaaaaa;
					}

					.list-table-item__left-center{
						position: relative;
						width: 100%;
						justify-content: space-between;
						.channel-icon{
							object-fit: contain;
							object-position: center;
							position: absolute;
							left: -60px;
							top: 0;
						}
						.left-center_item{
							text-align: left;
							display: flex;
							flex-direction: column;
							justify-content: space-between;
							.text1 {
								color: #aaaaaa;
								line-height: 18px;
								text-align: left;
								font-weight: 400;
								font-size: 13px;
							}

							.text2 {
								color: #333333;
								text-align: left;
								font-weight: 400;
								font-size: 14x;
							}

							.text3 {
								font-family: PingFangSC, PingFang SC;
								font-weight: 400;
								font-size: 13px;
								color: #aaaaaa;
								text-align: left;
								font-style: normal;
							}

							.text4 {
								color: #FF6C00;
								text-align: left;
								font-weight: 400;
								font-size: 24px;
							}
						}
						
					}
					
					.list-table-item__left-cargoTypeNames{
						align-items: center;
						div{
							display: -webkit-box;
							-webkit-line-clamp: 1;       /* 限制显示行数 */
							-webkit-box-orient: vertical;
							overflow: hidden;
							text-overflow: ellipsis;
						}
					}
				}

				.list-table-item__center {
					width: 272px;
					border-left: 1px solid #dddddd;
					border-right: 1px solid #dddddd;
					box-sizing: border-box;
					display: flex;
					flex-direction: column;
					justify-content: center;
					
				
					
					.text1 {
						font-family: D-DINExp, D-DINExp;
						font-weight: bold;
						font-size: 20px;
						color: #333333;
						line-height: 22px;
						text-align: center;
						font-style: normal;

						&::after {
							position: relative;
							top: -8px;
							left: 3px;
							display: inline-block;
							font-family: D, D;
							font-weight: normal;
							font-size: 12px;
							color: #333333;
							line-height: 13px;
							text-align: left;
							font-style: normal;
						}
					}

					.text2 {
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 13px;
						color: #aaaaaa;
						line-height: 18px;
						text-align: left;
						font-style: normal;
					}

					.text3 {
						font-family: D, D;
						font-weight: normal;
						font-size: 13px;
						color: #333333;
						line-height: 18px;
						text-align: left;
						font-style: normal;
					}

					.text4 {
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 13px;
						color: #333333;
						line-height: 18px;
						text-align: left;
						font-style: normal;
					}
				}

				.list-table-item__right {
					width:200px;
					box-sizing: border-box;
					padding-right: 20px;
					.detail-btn {
						outline: none;
						border: none;
						background: rgba(51, 112, 255, 0);
						border-radius: 8px;
						
						span {
							display: inline-block;
							font-family: PingFangSC, PingFang SC;
							font-weight: 500;
							font-size: 13px;
							color: #3370ff;
							line-height: 18px;
							text-align: center;
							font-style: normal;
						}
					
						&:hover {
							cursor: pointer;
						}
					}

					.choose-btn {
						outline: none;
						border: none;
						width: 200px;
						height: 50px;
						background: #3370ff;
						border-radius: 8px;
						box-sizing: border-box;

						span {
							display: inline-block;
							font-family: PingFangSC, PingFang SC;
							font-weight: 600;
							font-size: 14px;
							color: #ffffff;
							line-height: 20px;
							text-align: center;
							font-style: normal;
						}

						&:hover {
							cursor: pointer;
						}
					}

					.inline-ask-btn {
						width: 200px;
						height: 50px;
						border: 1px solid #CCCCCC;
						background: #fff;
						border-radius: 8px;
						box-sizing: border-box;
					
						span {
							display: inline-block;
							font-family: PingFangSC, PingFang SC;
							font-weight: 500;
							font-size: 13px;
							color: #333333;
							line-height: 18px;
							text-align: left;
							font-style: normal;
						}
					
						&:hover {
							cursor: pointer;
						}
					}
				}
			}
		}
	}
</style>